module.exports = __webpack_public_path__ + "static/img/rank_homepage_avatar1.25978d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank_homepage_avatar1.png
// module id = NFN4
// module chunks = 0